/**
 * Neutralizes URLs and IP addresses to prevent accidental clicks
 * @param {string} text - The string to defang
 * @returns {string} The defanged string or 'N/A'
 */
export const defang = (text) => {
  if (!text) return 'N/A';
  // Replace . with [.]
  return text.toString().replace(/\./g, '[.]');
};

/**
 * Generates the SecOps alert email template
 * @param {Object} finding - The finding object from scan results
 * @param {string} targetDomain - The protected target domain
 * @returns {string} The formatted email template
 */
export const generateSecOpsTemplate = (finding, targetDomain) => {
  const defangedSuspicious = defang(finding.typosquat_domain);
  const defangedTarget = defang(targetDomain);
  
  // Extract IP Address
  let ipAddress = 'N/A';
  if (finding.finding_metadata?.dns_analysis?.a_records?.length > 0) {
    ipAddress = finding.finding_metadata.dns_analysis.a_records.join(', ');
  } else if (finding.metadata?.dns_analysis?.a_records?.length > 0) {
    ipAddress = finding.metadata.dns_analysis.a_records.join(', ');
  }
  const defangedIp = defang(ipAddress);

  // Determine Infrastructure Status
  const statusIndicators = [];
  
  // DNS
  if (ipAddress !== 'N/A') statusIndicators.push('Active DNS (A records present)');
  
  // MX
  const mxRecords = finding.finding_metadata?.dns_analysis?.mx_records || finding.metadata?.dns_analysis?.mx_records;
  if (mxRecords && mxRecords.length > 0) statusIndicators.push('MX records configured (capable of receiving email)');
  
  // SSL & Active Site
  const httpCheck = finding.finding_metadata?.http_check || finding.metadata?.http_check;
  if (httpCheck) {
    if (httpCheck.ssl_valid) statusIndicators.push('Valid SSL certificate');
    if (httpCheck.status_code === 200) statusIndicators.push('Active web server (HTTP 200)');
  }
  
  const statusSummary = statusIndicators.length > 0 
    ? statusIndicators.join(' | ') 
    : 'No active infrastructure detected';

  const creationDate = (finding.creation_date && finding.creation_date !== '?') ? finding.creation_date : 'Unknown';
  const registrar = (finding.registrar && finding.registrar !== '?') ? finding.registrar : 'Unknown';

  return `Hi Corp Sec team,

Just flagging a suspicious domain mimicking our main domain. It looks like they are currently setting up the infrastructure for an upcoming phishing campaign.

Suspicious Domain: ${defangedSuspicious}
Target: ${defangedTarget}

IP Address: ${defangedIp}

Infrastructure Status: ${statusSummary}

Creation Date: ${creationDate}
Registrar: ${registrar}

I highly recommend a quick review to proactively block this domain on our network and proxies before any malicious content goes live.

Thanks,`;
};
